import React from 'react';
const logoSrc = require('../../images/bmo-logo-dark.png');


export default class Header extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        return (
            <div>
                <div className="row vertical-center">
                    <div className="col-md-6 orange">
                        <h1>{this.props.customer}</h1>
                    </div>
                    <div className="col-md-6 text-right hidden-sm hidden-xs print-logo">
                        <img style={{ height: '35px'}} src={logoSrc} />
                    </div>
                </div>
                <div className="row vertical-center">
                    <div className="col-md-6" style={{ marginTop: '-15px' }}>
                        <h3>{this.props.ordername}</h3>
                    </div>
                </div>
            </div>
        );
    }
}